/**
 * El formato único de las líneas de consola fuera de la sincronización.
 *
 * `services/syncLog.js` ya había fijado el criterio para los siete maestros:
 * un prefijo por área para poder filtrar, y el nivel decidido por el resultado
 * y no por la rama del código. Todo lo demás --facturación, cierre de caja, el
 * service worker, la configuración de entorno-- seguía escribiendo a mano, sin
 * prefijo y en el nivel que tocara, así que en un terminal con problemas la
 * consola era una lista plana donde no se distinguía el envío de una factura
 * del registro del service worker.
 *
 * Acá vive la misma idea para el resto de la aplicación. Un área llama a
 * `crearRegistro("area")` una sola vez y usa los tres niveles con el mismo
 * criterio de syncLog:
 *
 *     log    lo que se hizo, y sirve para reconstruir el flujo después
 *     warn   lo que salió distinto de lo esperado pero no impide seguir
 *     error  lo que corta la operación
 *
 * **Por qué no se silencia en producción.** Los terminales de tienda son
 * justamente donde aparecen los problemas que no se reproducen en desarrollo, y
 * la consola del navegador es la única herramienta de diagnóstico que hay ahí.
 * Lo que se quitó al homologar fue el ruido --"Cargando clientes...", volcados
 * de objetos enteros, avisos de que una función empezó y terminó-- no la traza
 * que sirve para entender qué pasó.
 */
export const crearRegistro = (area) => {
  const prefijo = `[${area}]`;

  return {
    log: (...datos) => console.log(prefijo, ...datos),
    warn: (...datos) => console.warn(prefijo, ...datos),
    error: (...datos) => console.error(prefijo, ...datos),
  };
};
